module.exports = __webpack_public_path__ + "img/11.079c0e0.jpg";